import { MenuItems as e, Remotes as s, UserRoles as r } from "./chunk353.js";
const a = Object.freeze({
  [e.Profile]: { href: "/profile", extraHrefs: [] },
  [e.Classes]: { href: "/classes", extraHrefs: [] },
  [e.Lessons]: { href: "/lessons", extraHrefs: ["/survey", "/discover-professions"] },
  [e.Materials]: { href: "/materials", extraHrefs: [] },
  [e.ParentMain]: { href: "/parentmain", extraHrefs: [] },
  [e.Professions]: { href: "/professions", extraHrefs: ["/profession"] },
  [e.Results]: { href: "/results", extraHrefs: [] },
  [e.Statistics]: { href: "/statistics", extraHrefs: [] }
}), i = Object.freeze({
  [e.Classes]: "/images/7773e535-ff87-45b0-87bb-7658c056dbbc_Classes.svg",
  [e.Lessons]: "/images/b88e89ac-f309-4ad2-900c-7123850b1a1c_Lessons.svg",
  [e.Materials]: "/images/d2668c53-99ca-4c03-957b-208846046a5b_Materials.svg",
  [e.ParentMain]: "/images/d2668c53-99ca-4c03-957b-208846046a5b_Materials.svg",
  [e.Professions]: "/images/bf72502a-4d71-4560-a5bb-9413a5731b2d_Professions.svg",
  [e.Results]: "/images/fc260ee2-7db7-4751-a996-e96f3c298c63_Results.svg",
  [e.Statistics]: "/images/6bb507f5-4be0-44b7-999c-ede4bbfe07b8_Statistics.svg"
}), t = Object.freeze({
  [s.Results]: {
    id: 10,
    link: {
      linkText: e.Results,
      href: a[e.Results].href,
      extraHrefs: a[e.Results].extraHrefs
    },
    image: {
      src: i[e.Results],
      alt: e.Results,
      height: 34,
      width: 34
    }
  },
  [s.Professions]: {
    id: 11,
    link: {
      linkText: e.Professions,
      href: a[e.Professions].href,
      extraHrefs: a[e.Professions].extraHrefs
    },
    image: {
      src: i[e.Professions],
      alt: e.Professions,
      height: 34,
      width: 34
    }
  },
  [s.Lessons]: {
    id: 9,
    link: {
      linkText: e.Lessons,
      href: a[e.Lessons].href,
      extraHrefs: a[e.Lessons].extraHrefs
    },
    image: {
      src: i[e.Lessons],
      alt: e.Lessons,
      height: 34,
      width: 34
    }
  },
  [s.ParentMain]: {
    id: 7,
    link: {
      linkText: e.ParentMain,
      href: a[e.ParentMain].href,
      extraHrefs: a[e.ParentMain].extraHrefs
    },
    image: {
      src: i[e.ParentMain],
      alt: e.ParentMain,
      height: 34,
      width: 34
    }
  },
  [s.Materials]: {
    id: 3,
    link: {
      linkText: e.Materials,
      href: a[e.Materials].href,
      extraHrefs: a[e.Materials].extraHrefs
    },
    image: {
      src: i[e.Materials],
      alt: e.Materials,
      height: 34,
      width: 34
    }
  },
  [s.Classes]: {
    id: 4,
    link: {
      linkText: e.Classes,
      href: a[e.Classes].href,
      extraHrefs: a[e.Classes].extraHrefs
    },
    image: {
      src: i[e.Classes],
      alt: e.Classes,
      height: 34,
      width: 34
    }
  },
  [s.Statistics]: {
    id: 5,
    link: {
      linkText: e.Statistics,
      href: a[e.Statistics].href,
      extraHrefs: a[e.Statistics].extraHrefs
    },
    image: {
      src: i[e.Statistics],
      alt: e.Statistics,
      height: 34,
      width: 34
    }
  }
}), f = Object.freeze({
  [r.SchoolAdmin]: [
    t[s.Classes],
    t[s.Statistics],
    t[s.Professions]
  ],
  [r.Teacher]: [
    t[s.Materials],
    t[s.Classes],
    t[s.Statistics],
    t[s.Professions]
  ],
  [r.Parent]: [
    t[s.ParentMain],
    t[s.Professions]
  ],
  [r.Pupil]: [
    t[s.Lessons],
    t[s.Results],
    t[s.Professions]
  ]
}), o = Object.freeze({
  [r.SchoolAdmin]: f[r.SchoolAdmin][0].link.href ?? "/",
  [r.Teacher]: f[r.Teacher][0].link.href ?? "/",
  [r.Parent]: f[r.Parent][0].link.href ?? "/",
  [r.Pupil]: f[r.Pupil][0].link.href ?? "/"
}), l = Object.freeze({
  [s.Results]: t[s.Results].link.href ?? "/",
  [s.Professions]: t[s.Professions].link.href ?? "/",
  [s.Lessons]: t[s.Lessons].link.href ?? "/",
  [s.ParentMain]: t[s.ParentMain].link.href ?? "/",
  [s.Materials]: t[s.Materials].link.href ?? "/",
  [s.Classes]: t[s.Classes].link.href ?? "/",
  [s.Statistics]: t[s.Statistics].link.href ?? "/"
}), c = {
  BASE_EMAIL_VALUE: "help@profilum.ru",
  BASE_PHONE_VALUE: "8 800 350-20-09",
  KRUZHKI_EMAIL_VALUE: "help@протворчество.москва",
  KRUZHKI_PHONE_VALUE: "+7 (495) 120-33-97",
  YEAR_TEXT: "Профилум"
}, E = /* @__PURE__ */ new Map([
  [
    "Default",
    {
      M: "/images/3dcf2042-5f9d-4ec9-9783-3d45b3ea8ddb_default.webp",
      F: "",
      N: ""
    }
  ],
  [
    r.Parent,
    {
      M: "/images/97fba47e-b4e4-4267-9a4c-499f49fc5168_parent-M.webp",
      F: "/images/b8b515fa-bfa4-415a-834e-92f51b4449b1_parent-F.webp",
      N: "/images/97fba47e-b4e4-4267-9a4c-499f49fc5168_parent-M.webp"
    }
  ],
  [
    r.Pupil,
    {
      M: "/images/0285bbbe-71af-4c12-9093-9bcecee3f81b_pupil-M.webp",
      F: "/images/7bcc71cc-1847-48b4-9370-84bcc3f73490_pupil-F.webp",
      N: "/images/0285bbbe-71af-4c12-9093-9bcecee3f81b_pupil-M.webp"
    }
  ],
  [
    r.SchoolAdmin,
    {
      M: "/images/6326de78-d761-47c1-b509-28285376c795_schooladmin-M.webp",
      F: "/images/dfebb64a-f961-418d-9298-16c72dcb0208_schooladmin-F.webp",
      N: "/images/6326de78-d761-47c1-b509-28285376c795_schooladmin-M.webp"
    }
  ],
  [
    r.Teacher,
    {
      M: "/images/7093642f-c349-44e8-9181-12bf59ae5e5e_teacher-M.webp",
      F: "/images/ccd67417-7b99-4013-84da-be7d8584256a_teacher-F.webp",
      N: "/images/7093642f-c349-44e8-9181-12bf59ae5e5e_teacher-M.webp"
    }
  ]
]), h = Object.freeze({
  YANDEX_METRIC_ID: 88169871,
  YANDEX_METRIC_ENABLED: !0,
  BACKEND_GATEWAY_DOMAIN: "https://gateway.prod.profilum.ru",
  BACKEND_B2G_DOMAIN: "https://bffb2g.prod.profilum.ru",
  BACKEND_FRONTEND_DOMAIN: "https://front-backend.profilum.ru",
  BACKEND_API_SURVEY_DOMAIN: "https://screening-tests.profilum.ru",
  BACKEND_IDENTITY_DOMAIN: "https://id.profilum.ru",
  API_SURVEY_IMAGE_URL: "https://class.profilum.ru/api/saas/files",
  S3_URL: "https://storage.yandexcloud.net/profilum-k8s-s3/staticfiles/pflm-static",
  B2GNEW_REMOTE_ENTRY: "https://b2gnew.profilum.ru/assets/remoteEntry.js",
  CLASSES_REMOTE_ENTRY: "https://classes.profilum.ru/assets/remoteEntry.js",
  LESSONS_REMOTE_ENTRY: "https://lessons.profilum.ru/assets/remoteEntry.js",
  MATERIALS_REMOTE_ENTRY: "https://materials.profilum.ru/assets/remoteEntry.js",
  PARENTMAIN_REMOTE_ENTRY: "https://parentmain.profilum.ru/assets/remoteEntry.js",
  RESULTS_REMOTE_ENTRY: "https://results.profilum.ru/assets/remoteEntry.js",
  STATISTICS_REMOTE_ENTRY: "https://statistics.profilum.ru/assets/remoteEntry.js",
  PROFESSIONS_REMOTE_ENTRY: "https://professions.profilum.ru/assets/remoteEntry.js",
  SURVEY_REMOTE_ENTRY: "https://survey.profilum.ru/assets/remoteEntry.js",
  USER_EXPERIENCE_REMOTE_ENTRY: "https://userexperience.profilum.ru/assets/remoteEntry.js",
  LOGIN_AND_REGISTRATION_REMOTE_ENTRY: "https://loginandregistration.profilum.ru/assets/remoteEntry.js",
  HOST_REMOTE_ENTRY: "https://class.profilum.ru/assets/remoteEntry.js"
}), _ = Object.freeze({
  M: "M",
  F: "F"
});
export {
  h as DEFAULT_APP_CONFIG,
  E as DefaultAvatars,
  c as FOOTER_DICTIONARY,
  _ as GENDERS,
  t as MENU_ITEMS_BY_MFS,
  f as MENU_ITEMS_BY_ROLE,
  l as MenuHomeMFSRoutes,
  o as MenuHomeRoutes,
  i as MenuIcons,
  a as MenuRoutes
};
